/**
 * DeskType
 * - Tag: 1033
 * - FIX Specification type: String
 * - Mapped type: string
 * @readonly
 * @public
 */
export const DeskType = Object.freeze({
    /** Agency */
    Agency: 'A',
    /** Arbitrage */
    Arbitrage: 'AR',
    /** Block trading */
    BlockTrading: 'B',
    /** Convertible desk */
    ConvertibleDesk: 'C',
    /** Central risk books */
    CentralRiskBooks: 'CR',
    /** Derivatives */
    Derivatives: 'D',
    /** Equity capital markets */
    EquityCapitalMarkets: 'EC',
    /** International */
    International: 'IN',
    /** Institutional */
    Institutional: 'IS',
    /** Other */
    Other: 'O',
    /** Preferred trading */
    PreferredTrading: 'PF',
    /** Proprietary */
    Proprietary: 'PR',
    /** Program trading */
    ProgramTrading: 'PT',
    /** Sales */
    Sales: 'S',
    /** Swaps */
    Swaps: 'SW',
    /** Trading desk or system non-market maker */
    TradingDeskSystem: 'T',
    /** Treasury */
    Treasury: 'TR',
    /** Floor Broker */
    FloorBroker: 'FB',
} as const);

type DeskType = (typeof DeskType)[keyof typeof DeskType];
